import heartIcon from '../assets/new-ui/myNFT/heart-icon.svg'

export default function ItemNFT(props) {
  const {image, id, rarityPercentage, rarityClass, fn} = props
  return (
    <div className='itemBox' onClick={() => fn()}>
      <div className='itemLike'>
        <img src={heartIcon} alt='' />
        <div>0</div>
      </div>
      <div className='itemImg'>
        {
          image
            ? <img src={image} alt='' />
            : <div>Minting...</div>
        }
        
      </div>
      <div className='itemInfo'>
        <div className='itemDetail'>
          <div className='itemIdTitle'>NFT Id</div>
          <div className='itemId'>{id ? id : 'Loading'}</div>
        </div>
        <div className='itemDetail'>
          <div>Rarity Point</div>
          <div className='itemPercent'>{rarityPercentage ? rarityPercentage : 'Loading'}</div>
        </div>
        <div className='itemDetail'>
          <div>Rarity Class</div>
          <div className='itemClass'>{rarityClass ? rarityClass : 'Loading'}</div>
        </div>
      </div>
    </div>
  )
}